export const adminTableHead = [
  // { name: "" },
  { name: "Campaign" },
  { name: "Prospects" },
  { name: "Sent" },
  { name: "Delivered" },
  { name: "Opened" },
  { name: "Responded" },
  { name: "Hot" },
  { name: "Warm" },
  { name: "Cold" },
];

export const leadTableHead = [
  { name: "Name" },
  { name: "Campaign" },
  // { name: "Activity" },
  { name: "Status" },
  { name: "" },
];

export const strategicPlanning = [
  { name: "No" },
  { name: "Profile Name" },
  { name: "Date" },
  { name: "Created By" },
  { name: "Status" },
  { name: "" },
];

export const strategicPlanning1 = [
  { name: "No" },
  { name: "Profile Name" },
  { name: "Date" },
  { name: "Created By" },
  // { name: "Status" },
  { name: "" },
];


export const campaignMessagesTableHead = [
  { name: "Name" },
  // { name: "Target Markets" },
  { name: "Status " },
  // { name: "Message Type" },
  { name: "" },
];

export const BlacklistTableHead = [
  { name: "Domain" },
  { name: "Date Added" },
  { name: "Added By" },
  { name: "" },
];

export const emailAccounts = [
  { name: "No" },
  { name: "Email Account" },
  { name: "Password" },
  { name: "Profile Type" },
  { name: "Email Server" },
  { name: "" },
];

export const emailAccounts1 = [
  { name: "No" },
  { name: "Email Account" },
  { name: "Password" },
  { name: "Profile Type" },
  { name: "Email Server" },
];

export const usersTableHead = [
  { name: "No" },
  { name: "Users" },
  { name: "" },
];

export const notificationTableHead = [
  { name: "Notification" },
  { name: "Date" },
  { name: "View" },
  { name: "Del" },
];

export const userReviewTableHead = [
  { name: "Title" },
  { name: "Date" },
  { name: "Delete" },
];

export const adminTableData = [
  {
    name: "Nisha Fatima",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
];

export const contentTableData = [
  {
    title: "title",
    category: "category name",
    subcategory: "subcategoryname",
    listened: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    subcategory: "subcategoryname",
    listened: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    subcategory: "subcategoryname",
    listened: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    subcategory: "subcategoryname",
    listened: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    subcategory: "subcategoryname",
    listened: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    subcategory: "subcategoryname",
    listened: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    subcategory: "subcategoryname",
    listened: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    subcategory: "subcategoryname",
    listened: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    subcategory: "subcategoryname",
    listened: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    subcategory: "subcategoryname",
    listened: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    subcategory: "subcategoryname",
    listened: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    subcategory: "subcategoryname",
    listened: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    subcategory: "subcategoryname",
    listened: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    subcategory: "subcategoryname",
    listened: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    subcategory: "subcategoryname",
    listened: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    subcategory: "subcategoryname",
    listened: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    subcategory: "subcategoryname",
    listened: "3,456,178",
    date: "12 July 2022",
  },
];

export const castTableData = [
  {
    title: "title",
    category: "category name",
    viewed: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    viewed: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    viewed: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    viewed: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    viewed: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    viewed: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    viewed: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    viewed: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    viewed: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    viewed: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    viewed: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    viewed: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    viewed: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    viewed: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    viewed: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    viewed: "3,456,178",
    date: "12 July 2022",
  },
  {
    title: "title",
    category: "category name",
    viewed: "3,456,178",
    date: "12 July 2022",
  },
];

export const subCategoryTableData = [
  {
    title: "title",
    date: "12 July 2022",
  },
  {
    title: "title",
    date: "12 July 2022",
  },
  {
    title: "title",
    date: "12 July 2022",
  },
  {
    title: "title",
    date: "12 July 2022",
  },
  {
    title: "title",
    date: "12 July 2022",
  },
  {
    title: "title",
    date: "12 July 2022",
  },
  {
    title: "title",
    date: "12 July 2022",
  },
  {
    title: "title",
    date: "12 July 2022",
  },
  {
    title: "title",
    date: "12 July 2022",
  },
  {
    title: "title",
    date: "12 July 2022",
  },
  {
    title: "title",
    date: "12 July 2022",
  },
  {
    title: "title",
    date: "12 July 2022",
  },
  {
    title: "title",
    date: "12 July 2022",
  },
  {
    title: "title",
    date: "12 July 2022",
  },
  {
    title: "title",
    date: "12 July 2022",
  },
  {
    title: "title",
    date: "12 July 2022",
  },
  {
    title: "title",
    date: "12 July 2022",
  },
];

export const tableHead = [
  { name: "Name" },
  { name: "Email" },
  { name: "Password" },
  { name: "Reset Password" },
  { name: "Date" },
  { name: "Edit" },
  { name: "Del" },
];

export const tableData = [
  {
    name: "Nisha Fatima",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
  {
    name: "Admin name",
    email: "nisha@gmail.com",
    password: ".......",
    date: "31 July 2022",
  },
];
